<template>
  <div> 
    <el-tag size="middle" style="margin: 0 5px;" closable v-for="(item,index) in value" :key="index"
    @close="closeTag(item)"
    >{{item.name}}</el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="$event.target.blur"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-card style="width: 500px;max-height: 200px;overflow-y: scroll;" v-if="tagList.length > 0">
      <el-button size="small" v-for="item in tagList" @click="clickTag(item.name, item.id)" :key="item.id"
      :type="item.name | valueClassFilter(tagStr)"
      :disabled="item.name | valueFilter(tagStr)"
      >{{item.name}}</el-button>
    </el-card>
  </div> 
</template>
<script>
export default {
  filters: {
    valueFilter(tag, tagStr){
      return tagStr.indexOf(tag) >= 0 ? true : false
    },
    valueClassFilter(tag,tagStr){
      return tagStr.indexOf(tag) >= 0 ? 'info' : 'success'
    }
  },
  props: {
    tagList: {
      required: true,
      type: Array,
    },
    value: {
      required: true,
      type: Array,
    }
  },
  created() {
    if (this.value.length > 0) {
      for (const t of this.value) {
        this.tagStr.push(t.name)
      }
    }
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      tagStr: [],
    }
  },
  beforeDestroy() {
    this.tagStr = [];
  },
  methods: {
    clickTag(tag, id){
      if(this.value.length >= 5) {
        this.$message.error('帖子关联标签最多5个');
        return false
      }
      let arr = [...this.value]
      arr.push({"id": id, "name": tag})
      this.tagStr.push(tag)
      this.$emit('input', arr)
    },
    closeTag(item) {
      let arr = [...this.value]
      if (arr.length > 0) {
        for (const a of arr) {
          if (a.tag === item.tag) {
            arr.splice(this.value.indexOf(a.tag), 1);
            break;
          }
        }
      }
      let tagStr = [...this.tagStr];
      tagStr.splice(this.tagStr.indexOf(item.tag), 1);
      this.tagStr = tagStr;
      this.$emit('input', arr)
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if(this.value.length >= 5) {
        this.$message.error('帖子关联标签最多5个');
        this.inputVisible = false;
        this.inputValue = '';
        return false
      }
      if (inputValue) {
        let arr = [...this.value]
        arr.push(inputValue);
        this.$emit('input', arr)
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
  }
}
</script>
<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>